<template>
    <div id="CreateTicimaxV2Channel">
        <div class="ticimax-container">
            <div class="logo-container">
                <img src="/static/img/ticimax.png" class="ticimax-logo" />
            </div>
            <div class="alert-box">
                <p>
                    Ticimax panel URL'niz üzerindeki
                    <span class="highlighzt">https://<span class="highlighted-part">www.example.com</span>/admin/</span>
                    kısmını domain kısmına yazmanız gerekiyor.
                </p>
            </div>
            <a-form class="ticimax-form">
                <a-form-item>
                    <label class="form-label">Domain Adresi</label>
                    <a-input
                        size="large"
                        v-model="form.domain"
                        autocomplete="off"
                    >
                        <a-icon slot="prefix" type="global" />
                    </a-input>
                </a-form-item>
                <a-form-item>
                    <label class="form-label">API Kullanıcı Adı</label>
                    <a-input
                        size="large"
                        v-model="form.apiUser"
                        autocomplete="off"
                    >
                        <a-icon slot="prefix" type="user" />
                    </a-input>
                </a-form-item>
                <a-form-item>
                    <label class="form-label">API Key</label>
                    <a-input
                        size="large"
                        v-model="form.apiKey"
                        autocomplete="off"
                    >
                        <a-icon slot="prefix" type="key" />
                    </a-input>
                </a-form-item>
                <div class="button-group">
                    <a-button type="default" size="large" @click="handleCancel">
                        Vazgeç
                    </a-button>
                    <a-button type="primary" size="large" @click="handleSubmit" :disabled="loading">
                        <template v-if="loading">
                            <a-spin />
                        </template>
                        <template v-else>
                            Bağlan
                        </template>
                    </a-button>
                </div>
            </a-form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "CreateTicimaxV2Channel",
    data() {
        return {
            form: {
                domain: "",
                apiUser: "",
                apiKey: "",
            },
            submitClicked: false,
            loading: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        completeCreateChannel(payload) {
            const data = {
                payload,
                type: "ticimax-v2",
                name: "Ticimax-V2",
            };
            return this.createChannel(data)
                .then(() => {
                    this.$message.success("Channel created successfully");
                    this.$emit("ok");
                })
                .catch((err) => {
                    this.$message.error("Failed to create channel");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubmit() {
            this.submitClicked = true;
            this.loading = true;
            const payload = {
                domain: this.form.domain.replace(/-/g, "."),
                apiUser: this.form.apiUser,
                apiKey: this.form.apiKey,
            };
            this.completeCreateChannel(payload);
        },
        handleCancel() {
            this.$emit("cancel");
        },
    }
};
</script>

<style lang="scss" scoped>
#CreateTicimaxV2Channel {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;

    .ticimax-container {
        width: 100%;

        .logo-container {
            text-align: center;
            margin-bottom: 2rem;

            .ticimax-logo {
                width: 120px;
                height: auto;
            }
        }

        .alert-box {
            background-color: #fff3cd;
            border: 1px solid #ffeeba;
            padding: 1rem;
            margin-bottom: 1.5rem;
            border-radius: 4px;
            text-align: center;

            .highlight {
                font-weight: bold;
            }

            .highlighted-part {
                background-color: yellow;
            }
        }

        .ticimax-form {
            .ant-form-item {
                margin-bottom: 1.5rem;

                &:last-child {
                    margin-bottom: 0;
                }

                .form-label {
                    display: block;
                    margin-bottom: 0.5rem;
                    font-weight: 600;
                    color: #333;
                    font-size: 14px;
                }
            }

            .ant-input-affix-wrapper {
                .ant-input {
                    padding-left: 40px;
                }

                .ant-input-prefix {
                    color: #bfbfbf;
                }
            }

            .button-group {
                display: flex;
                justify-content: flex-end;
                gap: 12px;
                margin-top: 2rem;

                .ant-btn {
                    min-width: 120px;
                    height: 40px;
                    font-weight: 500;
                }
            }
        }
    }
}
</style>
